<template>
  <div class="alert alert-warning" role="alert">
    Izpolnite obvezne podatke!
    <div class="small mt-1" v-if="$slots.default">
      <slot />
    </div>
  </div>
</template>

<script setup>
defineOptions({ name: "RequiredWarning" })
</script>
